import { create } from 'zustand';
import { WorkReponse } from '../../../model/work_response';
import { createDI } from '../../../context/di/di';
import { ApiError, useApi } from '../../../api/api';

/**
 * 詳細ポップアップ アクションを管理するための DI コンテキスト(アクション)
 */
export type TaskDetailAction = {
  getTaskDetails: (workId: number, planId: number) => Promise<WorkReponse>;
};

/**
 * 詳細ポップアップ 状態とアクションを管理するための DI コンテキストを作成
 */
const [Provider, use] = createDI<TaskDetailAction>();
export { Provider as TaskDetailProvider, use as useTaskDetailStore };

/**
 * 詳細ポップアップ 状態とアクション
 */
export const defaultTaskDetailStore = () => {
  const api = useApi();

  return create<TaskDetailAction>(() => {
    return {
      getTaskDetails: async (workId: number, planId: number) => {
        const resp = await api.path(`/api/works/${workId}/plans/${planId}`).get();
        if (resp.isError) {
          throw new ApiError(resp);
        }
        return resp.data as WorkReponse;
      },
    };
  });
};
